var template = require('./regulatory_disclosures_info.html.slim')
declare var angular

export class RegulatoryDisclosuresController {
  static $inject = ['locale', 'users', 'Profile', '$scope', '$routeParams']

  userLocale: null
  error: null
  isLoading: Boolean
  userId: String
  pepp: Boolean | String | null
  pedp: Boolean | String | null
  hio: Boolean | String | null
  insiderPro: Boolean | String | null
  proFirm: String | null
  insider: Boolean | String | null
  insiderSymbol: String | null
  ss: Boolean | String | null
  ssSymbol: String | null
  noneApply: Boolean | null
  isFormValid: Boolean = false
  showError: Boolean = false
  contentSaved: Boolean = false
  profileDetails: any


  constructor(private locale, private users, private Profile, public $scope, private $routeParams) {
    this.userLocale = this.locale.getLocale();
    this.isLoading = false;
    
    this.getData();
  
    if (this.users.getCurrentUser().roles.includes('staff')) {
      this.userId = this.$routeParams.userId;
    } else {
      this.userId = this.users.getCurrentUser().id;
    }
  }

  getData() {
    this.profileDetails = this.Profile.get().$promise.then((response) => { 
      this.setData(response);
      return response;
    });
  }


  isTrueOrYes(val) {
    return val === true || val === 'Yes';
  }

  setData(response) {
    if(response) {
      this.pepp = this.isTrueOrYes(response.pep) ? true : response.pep;
      this.pedp = this.isTrueOrYes(response.pedp) ? true : response.pedp;
      this.hio = this.isTrueOrYes(response.hio) ? true : response.hio;
      this.insiderPro = this.isTrueOrYes(response.insiderPro) ? true : response.insiderPro;
      this.proFirm = response.proFirm;
      this.insider = this.isTrueOrYes(response.insider) ? true : response.insider;
      this.insiderSymbol = response.insiderSymbol;
      this.ss = this.isTrueOrYes(response.ss) ? true : response.ss;
      this.ssSymbol = response.ssSymbol;
    }
    const checkboxes = [this.pepp, this.pedp, this.hio, this.insiderPro, this.insider, this.ss];
    if(checkboxes.every(val => val === false)) {
      this.noneApply = true;
    }
  }

  isValid() {
    let valid;
    this.contentSaved = false;
    const checkboxes = [this.pepp, this.pedp, this.hio, this.insiderPro, this.insider, this.ss];

    if(this.isTrueOrYes(this.pepp)) {
      this.pepp = true;
      this.noneApply = false;
      valid = true;
    }

    if(this.isTrueOrYes(this.pedp)) {
      this.pedp = true;
      this.noneApply = false;
      valid = true;
    }

    if(this.isTrueOrYes(this.hio)) {
      this.hio = true;
      this.noneApply = false;
      valid = true;
    }

    if(this.isTrueOrYes(this.insiderPro)) {
      this.insiderPro = true;
      this.noneApply = false;
      if(this.proFirm && valid !== false) {
        valid = true;
      } else {
        valid = false;
      }
    } else {
      this.proFirm = null;
    }

    if(this.isTrueOrYes(this.insider)) {
      this.insider = true;
      this.noneApply = false;
      if(this.insiderSymbol && valid !== false) {
        valid = true;
      } else {
        valid = false;
      }
    } else {
      this.insiderSymbol = null;
      this.ss = false;
      this.ssSymbol = null;
    }

    if(this.isTrueOrYes(this.ss)) {
      this.ss = true;
      this.noneApply = false;
      if(this.ssSymbol && valid !== false) {
        valid = true;
      } else {
        valid = false;
      }
    } else {
      this.ssSymbol = null;
    }

    if(checkboxes.every(val => !val)) {
      if(this.noneApply !== true) {
        valid = false;
      }
    }

    if(checkboxes.every(val => !val)) {
      if(this.noneApply !== true) {
        this.isFormValid = false;
        return false;
      }
    }

    this.isFormValid = valid !== false;
  }

  setNoneApply() {
    if(this.noneApply) {
      this.isFormValid = true;
      this.resetNoneApply();
    } else {
      this.isFormValid = false;
    }
  }

  resetNoneApply() {
    this.pepp = false;
    this.pedp = false;
    this.hio = false;
    this.insiderPro = false;
    this.insider = false;
    this.ss = false;
    this.proFirm = null;
    this.insiderSymbol = null;
    this.ssSymbol = null;
    this.contentSaved = false;
    this.isFormValid = true;
  }

  setValues() {
    this.pepp = !!this.pepp;
    this.pedp = !!this.pedp;
    this.hio = !!this.hio;
    this.insiderPro = !!this.insiderPro;
    this.insider = !!this.insider;
    this.ss = !!this.ss;
  }

  submitForm() {
    this.isValid();
    if(!this.isFormValid) {
      this.showError = true;
    } else {
      this.showError = false;
      this.setValues();
      this.Profile.addDisclosures({
        user_id: this.userId,
        pep: this.isTrueOrYes(this.pepp) ? true : false,
        pedp: this.isTrueOrYes(this.pedp) ? true : false,
        hio: this.isTrueOrYes(this.hio) ? true : false,
        insider_pro: this.isTrueOrYes(this.insiderPro) ? true : false,
        insider: this.isTrueOrYes(this.insider) ? true : false,
        ss: this.isTrueOrYes(this.ss) ? true : false,
        pro_firm: this.proFirm || null,
        insider_symbol: this.insiderSymbol || null,
        ss_symbol: this.ssSymbol || null
      }).$promise.then( () => { 
        this.getData();
        this.contentSaved = true
      });
    }
  }

  getPeppUrl() {
    if (this.userLocale === 'fr-ca') {
      return 'https://help.cidirectinvesting.com/what-is-a-politically-exposed-person-or-head-of-an-international-organization?kb_language=fr_FR'
    } else {
      return 'https://help.cidirectinvesting.com/en_US/what-is-a-politically-exposed-person-or-head-of-an-international-organization';
    }
  }
  
  getPedpUrl() {
    if (this.userLocale === 'fr-ca') {
      return 'https://help.cidirectinvesting.com/what-is-a-politically-exposed-person-or-head-of-an-international-organization?kb_language=fr_FR'
    } else {
      return 'https://help.cidirectinvesting.com/en_US/what-is-a-politically-exposed-person-or-head-of-an-international-organization';
    }
  }

  getHioUrl() {
    if (this.userLocale === 'fr-ca') {
      return 'https://help.cidirectinvesting.com/what-is-a-politically-exposed-person-or-head-of-an-international-organization?kb_language=fr_FR'
    } else {
      return 'https://help.cidirectinvesting.com/en_US/what-is-a-politically-exposed-person-or-head-of-an-international-organization';
    }
  }

  getCIROLink() {
    if (this.userLocale === 'fr-ca') {
      return 'https://www.ocri.ca/'
    } else {
      return 'https://www.ciro.ca/';
    }
  }

  getInsiderLink() {
    if (this.userLocale === 'fr-ca') {
      return 'https://help.cidirectinvesting.com/14778-questions-generales/reporting-issuers-reporting-insiders-and-significant-shareholders'
    } else {
      return 'https://help.cidirectinvesting.com/10762-general-questions/reporting-issuers-reporting-insiders-and-significant-shareholders';
    }
  }

  getTcpUrl() {
    if (this.userLocale === 'fr-ca') {
      return 'https://help.cidirectinvesting.com/ouvrir-un-compte/personne-ressource-de-confiance';
    } else {
      return 'https://help.cidirectinvesting.com/opening-an-account/what-is-a-trusted-contact-person';
    }
  }
}

angular.module('wbComponents')
  .controller("RegulatoryDisclosuresController", RegulatoryDisclosuresController)
  .directive('regulatoryDisclosures', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "RegulatoryDisclosuresController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
